<script>
export default {
  name: 'BaseModal',
  emits: ['close'],
  props: {
    size: {
      type: String,
      default: 'default', // 'default', 'large', or 'xlarge'
      validator: value => ['default', 'large', 'xlarge'].includes(value),
    },
  },
  computed: {
    modalWidth() {
      const sizes = {
        default: 'w-96',
        large: 'w-[640px]',
        xlarge: 'w-[1400px]',
      };
      return sizes[this.size] || sizes.default;
    },
  },
};
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/80 z-50"
    data-base-modal
  >
    <div
      :class="['bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg max-h-[80vh] overflow-y-auto', modalWidth]"
      @click.stop
    >
      <!-- Header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">
          <slot name="title" />
        </h1>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          @click="$emit('close')"
        />
      </div>

      <!-- Body -->
      <div>
        <slot />
      </div>

      <!-- Footer -->
      <div v-if="$slots.footer" class="flex justify-end gap-4 mt-4">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
